export default "__VITE_ASSET__BOZBdxXI__";